/**
 * 📋 복사용 글(wq-copy) — 생기부 문구·학부모 문자·가정통신문 본문처럼 그대로 붙여 넣을 글.
 *
 * 모델 출력: ```wq-copy 펜스, 첫 줄은 선택 `title: 제목`, 나머지는 본문.
 * 화면은 EnhancedMarkdown/CopyBlock 이 글 카드로 그리고, 글만 다루는 경로(복사·공유·익명 기록·읽어 주기)는
 * replaceCopyFences 로 제목 줄 + 본문 글이 된다.
 */

export const COPY_FENCE_LANG = 'wq-copy';

const TITLE_LINE_RE = /^[ \t]*(?:title|제목)[ \t]*[:：][ \t]*(.*?)[ \t]*$/i;
const CLOSED_FENCE_RE = /^ {0,3}(`{3,}|~{3,})[ \t]*wq-copy[ \t]*(?:\n([\s\S]*?))?\n {0,3}\1[ \t]*$/gm;
const OPEN_FENCE_RE = /^ {0,3}(?:`{3,}|~{3,})[ \t]*wq-copy[ \t]*(?:\n([\s\S]*))?$/m;
const TITLE_MAX = 60;

/** 펜스 안 글 → { title, body }. 제목 줄이 없으면 title 은 빈 글. */
export function parseCopyBlock(code) {
  const lines = String(code || '').replace(/\r\n?/g, '\n').split('\n');
  const first = lines.findIndex((line) => line.trim());
  let title = '';
  if (first >= 0) {
    const match = lines[first].match(TITLE_LINE_RE);
    if (match) {
      title = match[1].slice(0, TITLE_MAX);
      lines.splice(0, first + 1);
    }
  }
  const body = lines.join('\n').replace(/^\s*\n/, '').replace(/\s+$/, '');
  return { title, body };
}

// 본문 줄바꿈은 그대로 보여야 한다(편지·문자) — 마크다운에서 같은 문단 안 줄은 강제 줄바꿈으로 바꾼다.
const bodyAsMarkdown = (body) => body
  .split(/\n{2,}/)
  .map((paragraph) => paragraph.split('\n').map((line) => line.replace(/[ \t]+$/, '')).join('  \n'))
  .join('\n\n');

export const fenceToMarkdown = (code) => {
  const { title, body } = parseCopyBlock(code);
  const text = bodyAsMarkdown(body);
  return title ? `**${title.replace(/\*/g, '')}**\n\n${text}` : text;
};

/** 글만 다루는 경로용: wq-copy 펜스를 제목 줄 + 본문 글로 바꾼다. 스트리밍 중 닫히지 않은 펜스도 지금까지의 글로 바꾼다. */
export function replaceCopyFences(markdown) {
  const text = typeof markdown === 'string' ? markdown : '';
  if (!text.includes(COPY_FENCE_LANG)) return text;
  return text
    .replace(CLOSED_FENCE_RE, (match, fence, body) => fenceToMarkdown(body || ''))
    .replace(OPEN_FENCE_RE, (match, body) => fenceToMarkdown(body || ''))
    .replace(/\n{3,}/g, '\n\n');
}
